
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Force light theme for all users
const initializeTheme = () => {
  // Remove any existing theme classes
  document.documentElement.classList.remove("light", "dark");
  // Force light mode
  document.documentElement.classList.add("light");
  // Clear any stored theme preference to ensure consistent light mode
  localStorage.removeItem("theme");
};

// Run theme initialization before app renders
initializeTheme();

createRoot(document.getElementById("root")!).render(
  <App />
);
